import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from "react";
import TwitterCardTimeline from "./TwitterCardTimeline"; // eslint-disable-next-line require-await

export default /*#__PURE__*/(function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(domNode) {
    var readData, props;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            readData = function readData(prop) {
              var data = domNode.getAttribute("data-".concat(prop));
              return data ? JSON.parse(data) : null;
            };

            props = {
              isRehydrating: true,
              timelineDataSource: readData("timeline-data-source"),
              timelineOptions: readData("timeline-options")
            };
            return _context.abrupt("return", /*#__PURE__*/React.createElement(TwitterCardTimeline, props));

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
})();